import React from "react";

import clickWrap from "@js/helpers/click_wrap.js";

const ModalButton = function(props) {

  let classNames = [
    "btn",
  ];

  if ( props.dangerous ) {
    classNames.push("btn-danger");
  } else {
    classNames.push("btn-default");
  }

  let style = {};

  if (props.style) {
    style = {
      ...style,
      ...props.style,
    };
  }

  return props.onClick ? (
    <button
      type="button"
      className={ classNames.join(" ") }
      onClick={ clickWrap(props.onClick) }
      style={ style }
    >
      { props.children }
    </button>
  ) : null;

};

export default ModalButton;
